<template>
  <Navbar />
  <v-container>
    <main class="main">
      <RouterView />
    </main>
  </v-container>
</template>

<script>
import Navbar from '@/components/Navbar'

export default {
  name: 'App',
  components: {
    Navbar
  }
}
</script>

<style>
#app {
  font-family: Avenir, Arial, Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-fornt-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 60px;

}

</style>